import React, { useState } from 'react';
import { saveAuthToken } from './api';
import './Auth.css';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError('');
    try {
      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: username.trim().toLowerCase(), password }),
      });
      const body = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(body.error || 'Unable to log in');
      saveAuthToken(body.token);
      onLogin(body.user);
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="login-page">
      <form className="login-card" onSubmit={submit}>
        <h1>BSE3</h1>
        <label>
          <span>Username</span>
          <input
            autoFocus
            autoComplete="username"
            value={username}
            maxLength="40"
            onChange={(event) => setUsername(event.target.value.toLowerCase())}
          />
        </label>
        <label>
          <span>Password</span>
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </label>
        {error && <div className="auth-error">{error}</div>}
        <button type="submit" disabled={busy || !username.trim() || !password}>
          {busy ? 'Logging in…' : 'Login'}
        </button>
      </form>
    </main>
  );
};

export default Login;
